import {translation} from "@2d-front-monorepo/core";
import {formatCurrency} from "@2d-front-monorepo/permits-business";
import {PermitTranslations} from "@2d-front-monorepo/shared-translations";
import {JSX} from "react";
import {usePermits} from "../hooks/usePermits";
import {useUser} from "../hooks/useUser";

export default function TopUserInfo(): JSX.Element | undefined {
	const user = useUser();
	const {userState} = usePermits();

	return <div className="top-user-info">
		<span className="top-user-info__user">{translation(PermitTranslations.welcome_back, {name: user.name, email: user.email})}</span>
		{userState.balance > 0 &&
            <span className="top-user-info__wallet tabular-nums">{translation(PermitTranslations.wallet_balance, {balance: formatCurrency(userState.balance)})}</span>}
	</div>;
}
